import { ax } from '@src/utils/axios/axios'
import { BASE_API_URL } from '@src/constants'

interface Options {
  drsId: number | string
}

/**
 * Server-computed cost totals for one DRS, read from the stored DRS cost
 * tables. Same source and same overhead/total arithmetic as the monthly Shift
 * Profitability Report (apiProjectShiftCosts), so the two screens reconcile.
 *
 * Everything here is already a real number. node-pg hands numerics back as
 * strings and the Lambda coerces them before responding.
 */
export interface DRSShiftCostTotals {
  drs_summary_id: number
  drs_status_id: string | null
  shift_id: number | null
  project_id: string | null
  /** null when the DRS has no CrewPack -> Shift -> Project link */
  percentage_overhead: number | null
  project_revenue: number
  plan_project_revenue: number

  // Actual. material_cost includes cartage + fuel exactly as the report reports
  // it; material_product_cost + cartage_cost is that same money split for the
  // page's separate Materials and Cartage Cost rows.
  labour_cost: number
  material_cost: number
  material_product_cost: number
  cartage_cost: number
  subcontractor_cost: number
  mobile_asset_cost: number
  project_cost_items: number
  custom_shift_cost: number
  custom_mobile_asset_cost: number
  custom_subcontractor_cost: number
  custom_material_cost: number
  custom_cartage_cost: number
  custom_labour_cost: number
  subtotal_cost: number
  overhead_cost: number
  total_cost: number
  margin: number

  // Plan
  plan_labour_cost: number
  plan_material_cost: number
  plan_material_product_cost: number
  plan_cartage_cost: number
  plan_subcontractor_cost: number
  plan_mobile_asset_cost: number
  plan_project_cost_items: number
  plan_custom_shift_cost: number
  plan_custom_mobile_asset_cost: number
  plan_custom_subcontractor_cost: number
  plan_custom_material_cost: number
  plan_custom_cartage_cost: number
  plan_custom_labour_cost: number
  plan_subtotal_cost: number
  plan_overhead_cost: number
  plan_total_cost: number
  plan_margin: number
}

export const apiDRSShiftCostTotals = ({ drsId }: Options) => {
  return ax({
    method: 'GET',
    url: `${BASE_API_URL}/v2/reports/project-shift-costs`,
    params: { drsId },
  })
}
